import getApiClient from '@/plugins/api-client'

export default {
    confirmDeleteAccount() {
        const self = this,
            api = getApiClient(self.$store)

        api.delete(`delete_account`, {
            data: {
                password: self.password
            }
        })
            .then(() => {
                this.$store.commit('unsetTokens')
                self.errorMessage = null
                self.showConfirmationModal = false
                self.showSuccessModal = true
            })
            .catch(error => {
                self.errorMessage = error.response.data['hydra:description']
            })
    },

    logout() {
        this.$store.commit('unsetTokens')

        this.$router.push({
            name: 'Home'
        })
    }
}
